module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// /Users/Shared/Previously Relocated Items/Security/workspace/nb2-webpack3/node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module id = 89
// module chunks = 0 1 4